var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.9993,
    cy: 34.9983,
    r: 28.8596,
    fill: "#DB5F5F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.0409 36.837C69.5425 36.864 69.9723 36.4792 69.9864 35.9771C70.2054 28.1405 67.7863 20.4559 63.1177 14.1579C62.8186 13.7543 62.2459 13.6851 61.8502 13.9946C61.4546 14.3042 61.3859 14.8752 61.6845 15.2791C66.0826 21.23 68.3655 28.4818 68.1693 35.879C68.156 36.3812 68.5393 36.8099 69.0409 36.837Z",
    fill: "#DB5F5F",
    fillOpacity: 0.29
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1056 10.8944C59.4608 10.5392 59.4616 9.96235 59.0973 9.6165C55.2162 5.93211 50.5417 3.18659 45.4337 1.59135C44.9542 1.4416 44.4508 1.72322 44.3135 2.20644C44.1763 2.68965 44.4573 3.19141 44.9365 3.34183C49.7465 4.85151 54.1494 7.43754 57.8105 10.9033C58.1753 11.2486 58.7504 11.2496 59.1056 10.8944Z",
    fill: "#DB5F5F",
    fillOpacity: 0.29
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6999 1.23507C39.7692 0.737546 39.4221 0.276845 38.9229 0.220543C35.1212 -0.208277 31.2748 -0.0108569 27.5369 0.804939C27.0461 0.91205 26.748 1.40587 26.8678 1.89369C26.9877 2.38151 27.4801 2.67854 27.971 2.57213C31.4847 1.8105 35.0989 1.625 38.6721 2.02289C39.1713 2.07848 39.6307 1.7326 39.6999 1.23507Z",
    fill: "#DB5F5F",
    fillOpacity: 0.29
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6764 2.84514C23.5095 2.37133 22.9897 2.12136 22.5204 2.30047C21.0512 2.86118 19.6215 3.52027 18.2409 4.27326C17.7999 4.51379 17.6524 5.07141 17.9043 5.506C18.1562 5.9406 18.7121 6.08753 19.1534 5.84763C20.4355 5.15071 21.7622 4.53913 23.1248 4.01687C23.5939 3.83709 23.8432 3.31894 23.6764 2.84514Z",
    fill: "#DB5F5F",
    fillOpacity: 0.29
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6509 7.64903C14.3511 7.24601 13.7805 7.16142 13.3854 7.47164C13.0421 7.74118 12.7039 8.01713 12.3709 8.29933C11.9877 8.6241 11.9561 9.20004 12.2907 9.57468C12.6253 9.94932 13.1995 9.98075 13.5831 9.65652C13.8751 9.40978 14.1713 9.1681 14.4717 8.9316C14.8663 8.62082 14.9508 8.05204 14.6509 7.64903Z",
    fill: "#DB5F5F",
    fillOpacity: 0.29
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29 41L41 29M29 29L41 41",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.334cb9747a7eeb1b8fba62a6fb08c86f.svg";
export { ForwardRef as ReactComponent };